import React, {useState} from "react";
import PropTypes from "prop-types";
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import classnames from "classnames";
import AddAssetForm from "./AddTypoSquattingForm";
import {getPattern} from "../../../../shared/helpers/validators";
import {useCurrentUserQuery} from "../../../../queries/CurrentUser";
import {hasUserEditorPermissionOnFeature} from "../../../../shared/helpers/permissions";
import {PLATFORM_FEATURE_TYPOSQUATTING_PROJECTS} from "../../../../shared/helpers/features";
import getIntelligenceBlock from "../../profile_utils";
import ProfilePreferencesMessage from "../../../../shared/components/ProfilePreferencesMessage";

const TypoSquattingForm = ({
  project,
  assets,
  organization
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const {data: dataCurrentUser} = useCurrentUserQuery();
  const typoSquattingTypes = ['domain'];

  const {
    block: intelligenceBlock,
    unblockDate: unblockDate
  } = getIntelligenceBlock(organization, 'last_project_typosquatting_update_dt')
  const [typoSquatting, setTypoSquatting] = useState(typoSquattingTypes.map((type) => (assets.filter((rm) => new RegExp(getPattern(type)).test(rm.value)))))
  const previousTypoSquatting = typoSquattingTypes.map((type) => (assets.filter((rm) => new RegExp(getPattern(type)).test(rm.value))))
  const [formattedModalMessages, setFormattedModalMessages] = useState([])
  const [submitAll, setSubmitAll] = useState({toSubmit: [], toSubmitType: []})
  const [onlyAddition, setOnlyAddition] = useState(false)
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const getChanges = (mode, idx, type) => {

    let result = []
    typoSquattingTypes.map((typoSquattingType, index) => {
      let toBeAdded = []
      let toBeDeleted = []
      const typeResult = {}
      typeResult.type = typoSquattingType
      const getDifference = (array1, array2) => {
        return array1.filter(object1 => {
          return !array2.some(object2 => {
            return object1.value === object2.value;
          });
        });
      }
      const difference = getDifference(typoSquatting[index], previousTypoSquatting[index])
      const reverseDiff = getDifference(previousTypoSquatting[index], typoSquatting[index])
      const regexErrors = difference.filter((asset) => {
        const passesRegex = new RegExp(getPattern(typoSquattingType)).test(asset.value)
        if (!passesRegex) return asset
      })
      let toBeEdited = difference.filter((asset) => asset.uid && !asset?.isNew)
      if (mode !== 'deletion') {
        toBeAdded = difference.filter((asset) => !asset?.uid && asset.isNew)
      } else {
        if (type === typoSquattingType && previousTypoSquatting[index][idx]) {
          if (toBeEdited.length) toBeDeleted = [previousTypoSquatting[index][idx]]
          else toBeDeleted = [typoSquatting[index][idx]]
        }
        toBeEdited = toBeEdited.filter((asset) => {
          reverseDiff.filter((res) => !asset.value !== res.value && asset.uid === res.uid)
        })
      }
      typeResult.result = {
        toBeAdded: toBeAdded,
        toBeEdited: toBeEdited,
        toBeDeleted: toBeDeleted,
        regexErrors: regexErrors
      }
      result.push(typeResult)
    })
    return result
  }

  const getFormattedModalText = (mode, deletionUid, type) => {
    const changes = getChanges(mode, deletionUid, type)
    let messages = []
    let onlyAdditions = []
    typoSquattingTypes.map((typoSquattingType, index) => {
      const toBeAdded = changes[index].result.toBeAdded.map(a => a?.value)
      const toBeDeleted = changes[index].result.toBeDeleted.map(a => a?.value)
      const toBeEdited = changes[index].result.toBeEdited.map(a => a?.value)
      const regexErrors = changes[index].result.regexErrors.map(a => a?.value)
      const forDeletion = toBeDeleted.filter(function (val) {
        return val !== undefined && !regexErrors.includes(val);
      });
      const forAddition = toBeAdded.filter(function (val) {
        return val !== undefined && !regexErrors.includes(val);
      });
      const forEdition = toBeEdited.filter(function (val) {
        return val !== undefined && !regexErrors.includes(val);
      });
      let message = ProfilePreferencesMessage({
        preferences: {
          forAddition: forAddition,
          forEdition: forEdition,
          forDeletion: forDeletion,
          regexErrors: regexErrors,
        }, mode: mode,
        preferencesType: changes[index].type
      })
      const deletion = !!message.preferences.forDeletion.length
      const addition = !!message.preferences.forAddition.length
      const edition = !!message.preferences.forEdition.length
      const regexErr = !!message.preferences.regexErrors.length
      if (!addition && !edition && !deletion && !regexErr) message = null
      if (message){
        if ((addition || regexErr) && !deletion && !edition) {
          onlyAdditions.push(true)
        } else onlyAdditions.push(false)
        messages[index] = message
      }

    })
    if (onlyAdditions.every(v => v === true)) setOnlyAddition(true)
    else setOnlyAddition(false)
    return messages
  }

  const onChangeHandler = (change, type) => {
    const formIndex = change.target.name.split('.')[1]
    const newResource = {
      value: change.target.value,
      isNew: true
    }
    typoSquattingTypes.map((typoSquattingType, index) => {

      if (typoSquattingType === type) {

        if (typoSquatting[index].length) {
          if (typoSquatting[index][formIndex]?.uid) {
            newResource.isNew = false
            newResource.uid = typoSquatting[index][formIndex].uid
          }
          typoSquatting[index][formIndex] = newResource
        } else typoSquatting[index].push(newResource)

      }
      setFormattedModalMessages(getFormattedModalText())

    })
  }
  const onSubmitHandler = () => {
    typoSquattingTypes.map((typoSquattingType, index) => {
      if (typoSquatting[index].length) {
        setFormattedModalMessages(getFormattedModalText())
      }
    })

  }
  const onDeleteHandler = (idx, type, onlyMessage) => {
    if (!onlyMessage) {
      typoSquattingTypes.map((typoSquattingType, index) => {
          if (typoSquattingType === type && typoSquatting[index].length) {
            const tmpResources = typoSquatting[index]
            tmpResources.splice(idx, 1)
            typoSquatting[index] = tmpResources
            setTypoSquatting(typoSquatting)
          }
        }
      )
    }
    setFormattedModalMessages(getFormattedModalText('deletion', idx, type))
  }
  const onSubmitAll = (allResources, index) => {
    const typesToUpdate = []
    typoSquattingTypes.map((type, idx) => {
      typoSquatting[idx].map((res) => {
        allResources.map((res2) => {
          if (res.value === res2.value) {
            res.isNew = false
            res.uid = res2.uid
          }
        })
      })
      if (idx !== index) {
        typesToUpdate.push(type)
      }
      setSubmitAll({toSubmit: allResources, toSubmitType: typesToUpdate})
    })
  }

  return (
    <div className="tabs tabs--bordered-bottom">
      <div className="tabs__wrap">
        <Nav tabs>
          {
            typoSquattingTypes.map((type, index) => (
              <NavItem key={index}>
                <NavLink
                  className={classnames({active: activeTab === index})}
                  onClick={() => {
                    toggleTab(index)

                  }}
                >{type.toUpperCase()}</NavLink>
              </NavItem>
            ))
          }
        </Nav>
        <TabContent activeTab={activeTab}>
          {
            typoSquattingTypes.map((type, index) =>
              <TabPane tabId={index} key={index} onChange={(a) => onChangeHandler(a, type)}>
                <AddAssetForm
                  key={index}
                  project={project}
                  assets={typoSquatting[index].filter((rm) => new RegExp(getPattern(type)).test(rm.value))}
                  all_assets={typoSquatting}
                  organization={organization}
                  assetType={type}
                  allTypoSquattingTypes={typoSquattingTypes}
                  messages={formattedModalMessages}
                  buttonsDisabled={!hasUserEditorPermissionOnFeature(
                    dataCurrentUser?.data?.modules || [], PLATFORM_FEATURE_TYPOSQUATTING_PROJECTS
                  )}
                  deleteHandler={(index, type, onlyMessage) => onDeleteHandler(index, type, onlyMessage)}
                  submitHandler={() => onSubmitHandler()}
                  intelligenceBlock={intelligenceBlock}
                  unblockDate={unblockDate}
                  submit={(allResources) => onSubmitAll(allResources, index)}
                  submitAll={submitAll}
                  onlyAddition={onlyAddition}
                />
              </TabPane>
            )
          }
        </TabContent>
      </div>
    </div>
  )
}


TypoSquattingForm.propTypes = {
  project: PropTypes.object.isRequired,
  assets: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired
}


export default TypoSquattingForm;
